// PaymentClockFields — the two inputs behind a payment clock: net days and
// what they count from. One component so the vendor form, the PO create form
// and the PO page offer the same vocabulary and the same wording, and a new
// basis lands in all three by editing paymentClock.ts alone.
//
// Left blank for anything the numbers cannot express: a split schedule like
// "50% deposit, balance on delivery" stays in the prose terms and these stay
// empty, because half a truth here computes a confidently wrong cash date.

import React from 'react';
import { Field } from '../components/ui/Field';
import { Select } from '../components/ui/Select';
import { PAYMENT_BASIS_LABELS, PAYMENT_TERMS_BASES } from './paymentClock';

const PaymentClockFields: React.FC<{
  /** As typed. The caller converts to a number at save time. */
  days: string;
  basis: string;
  onDaysChange: (value: string) => void;
  onBasisChange: (value: string) => void;
  labelClassName: string;
  /** Distinct ids per host, for the labels. */
  idPrefix: string;
  disabled?: boolean;
}> = ({
  days, basis, onDaysChange, onBasisChange, labelClassName, idPrefix, disabled,
}) => (
  <>
    <div>
      <label className={labelClassName} htmlFor={`${idPrefix}-days`}>Net days</label>
      <Field
        id={`${idPrefix}-days`}
        type="number"
        min={0}
        max={365}
        step={1}
        inputMode="numeric"
        value={days}
        disabled={disabled}
        onChange={(e) => onDaysChange(e.target.value)}
      />
    </div>
    <div>
      <label className={labelClassName} htmlFor={`${idPrefix}-basis`}>Counted from</label>
      <Select
        id={`${idPrefix}-basis`}
        label="Counted from"
        value={basis}
        disabled={disabled}
        onChange={onBasisChange}
        options={[
          { key: '', label: 'Not set' },
          ...PAYMENT_TERMS_BASES.map((b) => ({ key: b, label: PAYMENT_BASIS_LABELS[b] })),
        ]}
      />
    </div>
  </>
);

export default PaymentClockFields;
